import React, { Component } from "react";
import { connect } from "react-redux";
import BadReview from "../components/BadReviews";

import { viewAllBadReview } from "../action";
export class Controller extends Component {
  render() {
    return <BadReview {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    viewAllBadReview: (
      token,
      user_id,
      searchInput,
      page,
      pageSize,
      selectedDate,
      selectedTime,
      selectedStatus
    ) => {
      dispatch(
        viewAllBadReview(
          token,
          user_id,
          searchInput,
          page,
          pageSize,
          selectedDate,
          selectedTime,
          selectedStatus
        )
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
